import React, { ReactNode } from 'react';
import { styled } from 'styled-components';

const Horizontal = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 5px;
  width: 100%;
`;

const HorizontalRight = styled.div`
  max-width: 100%;
  margin-left: auto;
`;

interface BetweenLayoutProps {
  left?: ReactNode;
  right?: ReactNode;
  className?: string;
}
/**
 * 레이아웃 컴포넌트
 *
 * 주로 테이블 위에 쓰여서
 * ```
 * | 왼 쪽 | ---------- |오 른 쪽|
 * ```
 * 으로 나타내는데 사용됨
 * 공간이 모자라면
 * ```
 * | 왼 쪽 | -----
 * ----- |오 른 쪽|
 * ```
 * 왼쪽이 위로 오른쪽이 아래로 내려간다
 */
export const BetweenLayout = ({
  left,
  right,
  className,
}: BetweenLayoutProps) => {
  return (
    <Horizontal className={className}>
      {left}
      {right && <HorizontalRight>{right}</HorizontalRight>}
    </Horizontal>
  );
};
